import * as createVote from "@/api/votes/create";

export default {
	namespaced: true,
	state: {
		vote: {},
		error: null,
	},
	getters: {
		readVote: (state) => state.vote,
		readError: (state) => state.error,
	},
	mutations: {
		SET_VOTE(state, payload) {
			state.vote = payload;
		},
		SET_ERROR(state, payload) {
			state.error = payload;
		},
	},
	actions: {
		async createVote({ commit, getters, rootGetters }) {
			let token = rootGetters["loginStore/readToken"];
			let createVoteRes = await createVote
				.createVote(token, getters.readVote)
				.then(() => {
					return true;
				})
				.catch((error) => {
					if (error.response) {
						let message =
							error.response.data.message ||
							error.response.data.detail[0].msg;
						message == "Token expired"
							? commit("loginStore/SET_ACCESS_TOKEN", null, {
									root: true,
							  })
							: message
							? commit("SET_ERROR", message)
							: commit("SET_ERROR", "Algo salió mal");
					} else {
						console.log(error);
						commit("SET_ERROR", error);
					}
				});
			return createVoteRes;
		},
	},
};
